import {PlanInfo, SupportedCountryCode} from 'utils/stripePlans';

/**
 * List of US states for form dropdowns
 * Each state has a text (full name) and value (uppercase two-letter abbreviation)
 */
export const US_STATES = [
  {text: 'Alabama', value: 'AL'},
  {text: 'Alaska', value: 'AK'},
  {text: 'Arizona', value: 'AZ'},
  {text: 'Arkansas', value: 'AR'},
  {text: 'California', value: 'CA'},
  {text: 'Colorado', value: 'CO'},
  {text: 'Connecticut', value: 'CT'},
  {text: 'Delaware', value: 'DE'},
  {text: 'Florida', value: 'FL'},
  {text: 'Georgia', value: 'GA'},
  {text: 'Hawaii', value: 'HI'},
  {text: 'Idaho', value: 'ID'},
  {text: 'Illinois', value: 'IL'},
  {text: 'Indiana', value: 'IN'},
  {text: 'Iowa', value: 'IA'},
  {text: 'Kansas', value: 'KS'},
  {text: 'Kentucky', value: 'KY'},
  {text: 'Louisiana', value: 'LA'},
  {text: 'Maine', value: 'ME'},
  {text: 'Maryland', value: 'MD'},
  {text: 'Massachusetts', value: 'MA'},
  {text: 'Michigan', value: 'MI'},
  {text: 'Minnesota', value: 'MN'},
  {text: 'Mississippi', value: 'MS'},
  {text: 'Missouri', value: 'MO'},
  {text: 'Montana', value: 'MT'},
  {text: 'Nebraska', value: 'NE'},
  {text: 'Nevada', value: 'NV'},
  {text: 'New Hampshire', value: 'NH'},
  {text: 'New Jersey', value: 'NJ'},
  {text: 'New Mexico', value: 'NM'},
  {text: 'New York', value: 'NY'},
  {text: 'North Carolina', value: 'NC'},
  {text: 'North Dakota', value: 'ND'},
  {text: 'Ohio', value: 'OH'},
  {text: 'Oklahoma', value: 'OK'},
  {text: 'Oregon', value: 'OR'},
  {text: 'Pennsylvania', value: 'PA'},
  {text: 'Rhode Island', value: 'RI'},
  {text: 'South Carolina', value: 'SC'},
  {text: 'South Dakota', value: 'SD'},
  {text: 'Tennessee', value: 'TN'},
  {text: 'Texas', value: 'TX'},
  {text: 'Utah', value: 'UT'},
  {text: 'Vermont', value: 'VT'},
  {text: 'Virginia', value: 'VA'},
  {text: 'Washington', value: 'WA'},
  {text: 'West Virginia', value: 'WV'},
  {text: 'Wisconsin', value: 'WI'},
  {text: 'Wyoming', value: 'WY'},
];

export const INSURANCE_PROVIDERS = [
  {label: 'Aetna', value: 'aetna', payerId: 'aetna'},
  {label: 'Anthem', value: 'anthem', payerId: 'blue_cross_blue_shield'},
  {label: 'Blue Cross Blue Shield', value: 'blue_cross_blue_shield', payerId: 'blue_cross_blue_shield'},
  {label: 'Cigna', value: 'cigna', payerId: 'cigna'},
  {label: 'Florida Blue', value: 'florida_blue', payerId: 'blue_cross_blue_shield'},
  {label: 'Healthy Blue', value: 'healthy_blue', payerId: 'blue_cross_blue_shield'},
  {label: 'Humana', value: 'humana', payerId: 'humana'},
  {label: 'Medicare', value: 'medicare', payerId: 'medicare'},
  {label: 'Oscar', value: 'oscar', payerId: 'oscar'},
  {label: 'TRICARE', value: 'tricare', payerId: 'tricare'},
  {label: 'United Healthcare', value: 'united_healthcare', payerId: 'united_healthcare'},
  {label: 'Other', value: 'other'},
];

// Follow-up to picking Medicare. Original Medicare is Parts A + B together;
// Medigap only pairs with Original, never with Advantage.
export const MEDICARE_PLAN_TYPES = [
  {text: 'Original Medicare (Parts A & B)', value: 'original'},
  {text: 'Original Medicare + a supplement plan (Medigap)', value: 'original_medigap'},
  {text: 'Medicare Advantage (Part C), e.g. through Humana, UnitedHealthcare, or Aetna', value: 'advantage'},
  {text: 'Part A only', value: 'part_a_only'},
  {text: 'Part B only', value: 'part_b_only'},
  {text: 'Not sure', value: 'not_sure'},
];

// Shown on both not-covered screens (/start and /book-appointment) when the
// patient picked Medicare, in place of the generic coverage copy.
export const MEDICARE_WAITLIST_COPY = {
  headline: "We don't have availability for more Medicare patients right now",
  body: "We're working on expanding our Medicare coverage with more clinicians. Leave your email and we'll let you know once we're taking more patients.",
};

export const INSURANCE_STATES = [
  {state: 'VA', providers: ['aetna', 'anthem', 'blue_cross_blue_shield', 'united_healthcare', 'medicare', 'other']},
  {
    state: 'CA',
    providers: ['aetna', 'anthem', 'blue_cross_blue_shield', 'cigna', 'united_healthcare', 'medicare', 'other'],
  },
  {state: 'OH', providers: ['aetna', 'anthem', 'blue_cross_blue_shield', 'united_healthcare', 'medicare', 'other']},
  {state: 'GA', providers: ['aetna', 'anthem', 'blue_cross_blue_shield', 'united_healthcare', 'medicare', 'other']},
  {state: 'MD', providers: ['aetna', 'anthem', 'blue_cross_blue_shield', 'united_healthcare', 'medicare', 'other']},
  {
    state: 'TX',
    providers: [
      'aetna',
      'anthem',
      'blue_cross_blue_shield',
      'cigna',
      'united_healthcare',
      'humana',
      'medicare',
      'other',
    ],
  },
  {state: 'AL', providers: ['aetna', 'anthem', 'blue_cross_blue_shield', 'united_healthcare', 'medicare', 'other']},
  {
    state: 'CO',
    providers: ['aetna', 'anthem', 'blue_cross_blue_shield', 'cigna', 'united_healthcare', 'medicare', 'other'],
  },
  {state: 'WA', providers: ['aetna', 'anthem', 'blue_cross_blue_shield', 'united_healthcare', 'medicare', 'other']},
  {state: 'MD', providers: ['aetna', 'anthem', 'blue_cross_blue_shield', 'united_healthcare', 'medicare', 'other']},
  {state: 'CT', providers: ['aetna', 'anthem', 'blue_cross_blue_shield', 'united_healthcare', 'medicare', 'other']},
  {state: 'KY', providers: ['aetna', 'anthem', 'blue_cross_blue_shield', 'united_healthcare', 'medicare', 'other']},
  {state: 'NJ', providers: ['aetna', 'anthem', 'blue_cross_blue_shield', 'united_healthcare', 'medicare', 'other']},
  {state: 'AL', providers: ['aetna', 'anthem', 'blue_cross_blue_shield', 'united_healthcare', 'medicare', 'other']},
  {
    state: 'FL',
    providers: [
      'aetna',
      'anthem',
      'blue_cross_blue_shield',
      'cigna',
      'florida_blue',
      'united_healthcare',
      'medicare',
      'other',
    ],
  },
  {
    state: 'MO',
    providers: ['aetna', 'anthem', 'blue_cross_blue_shield', 'healthy_blue', 'united_healthcare', 'medicare', 'other'],
  },
  {
    state: 'IL',
    providers: [
      'aetna',
      'anthem',
      'blue_cross_blue_shield',
      'healthy_blue',
      'united_healthcare',
      'humana',
      'medicare',
      'other',
    ],
  },
  {
    state: 'NC',
    providers: [
      'aetna',
      'anthem',
      'blue_cross_blue_shield',
      'cigna',
      'healthy_blue',
      'united_healthcare',
      'medicare',
      'other',
    ],
  },
  {
    state: 'SC',
    providers: ['aetna', 'blue_cross_blue_shield', 'healthy_blue', 'united_healthcare', 'medicare', 'other'],
  },
  {
    state: 'MA',
    providers: ['aetna', 'blue_cross_blue_shield', 'cigna', 'humana', 'united_healthcare', 'medicare', 'other'],
  },
  {state: 'NH', providers: ['aetna', 'blue_cross_blue_shield', 'united_healthcare', 'humana', 'medicare', 'other']},
  {
    state: 'NY',
    providers: ['aetna', 'blue_cross_blue_shield', 'cigna', 'united_healthcare', 'humana', 'medicare', 'other'],
  },
  {state: 'OH', providers: ['aetna', 'blue_cross_blue_shield', 'united_healthcare', 'humana', 'medicare', 'other']},
  {state: 'PA', providers: ['aetna', 'blue_cross_blue_shield', 'united_healthcare', 'humana', 'medicare', 'other']},
  {state: 'WI', providers: ['aetna', 'blue_cross_blue_shield', 'united_healthcare', 'humana', 'medicare', 'other']},
  {state: 'Default', providers: ['aetna', 'blue_cross_blue_shield', 'united_healthcare', 'medicare', 'other']},
];

export const insomniaPlans: Partial<Record<SupportedCountryCode, PlanInfo>> = {
  US: {
    price: 0.5,
    introPrice: 0.5,
    perDay: 0.5,
    percentOff: null,
    label: '$',
    id: 'insomnia_clinic_card_hold',
    purchasePrice: 50,
    duration: 'one-time hold',
    frequency: 'Card Hold to Confirm RISE Session',
    introDuration: 'one-time hold',
    currency: 'usd',
    product: 'web_acquisition_week',
    payPalPlanId: 'insomnia_clinic_card_hold',
    trial_duration: 0,
  },
};
